import { useLocation, useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";
import { chatWidgetLoaded, loadChatWidget } from "@/lib/chatWidget";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  // Chat widget on public pages only. A widget can't be cleanly torn
  // down once injected, so entering the app from a page that loaded it
  // reloads once — the dashboard then starts without it.
  const inApp = useLocation().pathname.startsWith("/dashboard");
  useEffect(() => {
    if (!inApp) loadChatWidget();
    else if (chatWidgetLoaded()) window.location.reload();
  }, [inApp]);
  return element;
}
